import { IOffersState } from 'state/global-state/models/loyalty/offers/offers.types';
import {
  LoyaltyOffer,
  LoyaltySystemwideTierGroup,
  isLoyaltyOffer,
  isLoyaltySystemwideTierGroup,
} from 'state/loyalty/types';

export function removeSystemwideTierGroups(
  offers: (LoyaltyOffer | LoyaltySystemwideTierGroup)[]
): LoyaltyOffer[] {
  return offers.filter(isLoyaltyOffer).filter(Boolean);
}

export function extractSystemwideTierGroups(
  offers: (LoyaltyOffer | LoyaltySystemwideTierGroup)[]
): LoyaltySystemwideTierGroup[] {
  return offers.filter(isLoyaltySystemwideTierGroup).filter(Boolean);
}

type OfferToTierGroupMap = Record<string, LoyaltySystemwideTierGroup>;

export function mapOffersToTierGroup(offers: IOffersState['cmsOffers']): OfferToTierGroupMap {
  const map: OfferToTierGroupMap = {};
  const tierGroups = extractSystemwideTierGroups(offers);

  for (const tierGroup of tierGroups) {
    const offers = tierGroup.offers ?? [];
    for (const offer of offers) {
      if (!isLoyaltyOffer(offer) || !offer?.loyaltyEngineId) {
        continue;
      }

      map[offer.loyaltyEngineId] = tierGroup;
    }
  }

  return map;
}
